import './Servicos.css'
import { useFadeUp } from '../hooks/usefadeup'

interface ParticularService {
  label: string
  imagePath: string
}

interface EmpresaService {
  title: string
  imagePath: string
  items: string[]
}

const particulares: ParticularService[] = [
  { label: 'Seguro Automóvel', imagePath: '/srv_auto_particular_1781686806548.png' },
  { label: 'Seguro de Habitação', imagePath: '/Patrimonial.jpg' },
  { label: 'Recheio de Casa', imagePath: '/recheiodecasa.jpg' },
  { label: 'Seguro de Saúde', imagePath: '/SEGURODESAUDE.jpg' },
  { label: 'Seguro de Vida', imagePath: '/srv_vida_1781686819132.png' },
  { label: 'Acidentes Pessoais', imagePath: '/srv_acidentes_trabalho_1781686897190.png' },
  { label: 'Viagem', imagePath: '/insurance-quote.png' },
]

const empresas: EmpresaService[] = [
  {
    title: 'Seguros Patrimoniais e Operacionais',
    imagePath: '/srv_casa_1781686852397.png',
    items: [
      'Todos os Riscos Operacionais (All Risks)',
      'Incêndio e Riscos Associados',
      'Recheio de Escritório e Conteúdo Empresarial',
      'Equipamento Electrónico',
      'Quebra de Vidros',
      'Roubo e Furto Qualificado',
      'Perda de Lucros (Business Interruption)',
    ],
  },
  {
    title: 'Seguros de Engenharia e Construção',
    imagePath: '/srv_petroleo_energia_1781686933019.png',
    items: [
      'Seguro de Empreitada (CAR)',
      'Seguro de Montagem (EAR)',
      'Máquinas e Equipamentos de Construção',
      'Avaria de Máquinas',
      'Equipamento de Contratantes',
    ],
  },
  {
    title: 'Responsabilidades e Linhas Financeiras',
    imagePath: '/srv_responsabilidade_1781686921458.png',
    items: [
      'Responsabilidade Civil Geral',
      'Responsabilidade Civil Profissional (E&O)',
      'Responsabilidade Civil Patronal',
      'Responsabilidade Civil de Produtos',
      'Responsabilidade Civil para Directores e Administradores (D&O)',
      'Cauções e Garantias Financeiras',
    ],
  },
  {
    title: 'Seguros de Transportes e Logística',
    imagePath: '/seguro_transporte.png',
    items: [
      'Mercadorias em Trânsito (GIT)',
      'Seguro Marítimo (Marine Cargo)',
      'Casco Marítimo',
      'Responsabilidade do Transportador',
    ],
  },
  {
    title: 'Frota e Equipamentos',
    imagePath: '/FrotaEquipamentos2.jpg',
    items: [
      'Seguro Automóvel de Frota',
      'Equipamentos Móveis e Pesados',
      'Máquinas Industriais e Equipamentos Especializados',
    ],
  },
  {
    title: 'Pessoas e Benefícios Corporativos',
    imagePath: '/srv_acidentes_trabalho_1781686897190.png',
    items: [
      'Acidentes de Trabalho (WCAA)',
      'Seguro de Saúde Empresarial',
      'Seguro de Vida em Grupo',
      'Acidentes Pessoais',
      'Benefícios para Colaboradores',
    ],
  },
]

export default function Servicos() {
  const sectionRef = useFadeUp<HTMLElement>()

  return (
    <section id="servicos" className="servicos" ref={sectionRef}>
      <div className="sv-shell">
        {/* Standardized header matching other sections */}
        <header className="sv-header" data-fade>
          <h2 className="sv-title">Nossos Serviços</h2>
          <p className="sv-subtitle">
            Descubra as soluções ideais e sob medida de proteção que temos para si e para a sua empresa.
          </p>
        </header>

        {/* Soluções para Particulares */}
        <div className="sv-category" data-fade data-fade-delay="120">
          <h3 className="sv-category-title">Soluções para Particulares</h3>
          <ul className="sv-service-grid sv-service-grid--particulares">
            {particulares.map((service) => (
              <li key={service.label} className="sv-service-card sv-service-card--particular">
                <div className="sv-card-img-wrapper">
                  <img src={service.imagePath} alt={service.label} loading="lazy" />
                </div>
                <div className="sv-service-body">
                  <h4>{service.label}</h4>
                </div>
                <a
                  className="sv-service-cta"
                  href={`/cotacoes?service=${encodeURIComponent(service.label)}`}
                >
                  Pedir Cotação
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Soluções para Empresas */}
        <div className="sv-category" data-fade data-fade-delay="200">
          <h3 className="sv-category-title">Soluções para Empresas</h3>
          <ul className="sv-service-grid sv-service-grid--empresas">
            {empresas.map((service) => (
              <li key={service.title} className="sv-service-card sv-service-card--empresa">
                <div className="sv-card-img-wrapper">
                  <img src={service.imagePath} alt={service.title} loading="lazy" />
                </div>
                <div className="sv-service-body">
                  <h4>{service.title}</h4>
                  <ul className="sv-card-list">
                    {service.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
                <a
                  className="sv-service-cta"
                  href={`/cotacoes?service=${encodeURIComponent(service.title)}`}
                >
                  Consultar Solução
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}